import type { GroupAdminItem, LC_GroupAdminItem } from '../types/groupAdmins.types';


export function mapGroupAdminItem(transport: LC_GroupAdminItem): GroupAdminItem {
  return {
    employeeId: transport.employeeId,
    employeeName: transport.employeeName?.trim() ?? '',
    employeeTaxIdentificationNumber: transport.employeeTaxIdentificationNumber?.trim() ?? '',
  };
}
